import { useCallback } from "react";
import subscribeEvent from "./subscribeEvent";
const unknownToError = (err, fallbackMsg = "Unexpected error") => {
  const msg = err instanceof Error ? err.message : typeof err === "string" ? err : fallbackMsg;
  return new Error(msg);
};
const useHandleNextInQueue = (siteKey, queueRef) => useCallback(() => {
  if (siteKey === null) {
    return;
  }
  do {
    const item = queueRef.current.shift();
    if (item === void 0) {
      break;
    }
    const { action, onComplete, onError } = item;
    subscribeEvent(() => {
      const execute = window.grecaptcha?.execute ?? null;
      if (execute !== null) {
        execute(siteKey, { action }).then(onComplete).catch((err) => {
          onError(unknownToError(err));
        });
        return;
      }
      onError(new Error("Bad execute()."));
    });
  } while (true);
}, [queueRef, siteKey]);
var useHandleNextInQueue_default = useHandleNextInQueue;
export {
  useHandleNextInQueue_default as default
};
